import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import {
  Link as LinkIcon,
} from '@mui/icons-material';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.vars.palette.app.tooltipBackground,
    color: theme.vars.palette.text.primary,
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    border: `1px solid ${theme.vars.palette.app.tooltipBorder}`,
  },
}));

const LinkDetail = ({destUrl, trackers}) => (
  <Box sx={{p: 1}}>
    <Typography sx={{"&:not(:last-child)": {mb: 1.5}}}>
      {destUrl || 'No Landing URL'}
    </Typography>
    {trackers?.imp && (
    <>
      <Typography component="h4" variant="overline">Impression Trackers:</Typography>
      <List dense={true}>
      {trackers.imp.map((tkr, i) =>
        <ListItem key={i} sx={{p: 0}}>
          <ListItemIcon sx={{minWidth: 0}}><LinkIcon /></ListItemIcon>
          <ListItemText sx={{ml: 1}} primary={tkr} />
        </ListItem>
      )}
      </List>
    </>
    )}
    {trackers?.clk && (
    <>
      <Typography component="h4" variant="overline">Click Trackers:</Typography>
      <List dense={true}>
      {trackers.clk.map((tkr, i) =>
        <ListItem key={i} sx={{p: 0}}>
          <ListItemIcon sx={{minWidth: 0}}><LinkIcon /></ListItemIcon>
          <ListItemText sx={{ml: 1}} primary={tkr} />
        </ListItem>
      )}
      </List>
    </>
    )}
  </Box>
);

const LinkView = ({destUrl, trackers}) => (
  <HtmlTooltip title={<LinkDetail destUrl={destUrl} trackers={trackers} />}>
    <Typography component="span" noWrap sx={{display: 'block', width: '100%', maxWidth: '100%', minWidth: 0}}>
      {destUrl || 'No Landing URL'}
    </Typography>
  </HtmlTooltip>
);

export default LinkView;
